import { useTranslation } from 'react-i18next';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import OutsideAlerter from 'shared/components/outside-alerter/outside-alerter';

import { FilterChipProps, useFilterChip } from './hooks';

import './filter-chip.scss';

const FilterChip = ({
  options,
  onOptionSelected,
  placeHolder,
  initialSelectedOption,
  disabled,
}: Readonly<FilterChipProps>): React.JSX.Element => {
  const { t } = useTranslation('filterChip');

  const { isOpen, close, toggleIsOpen, handleOnMenuItemClicked, chipLabel, chipActive } = useFilterChip({
    options,
    onOptionSelected,
    placeHolder,
    initialSelectedOption,
  });

  return (
    <OutsideAlerter funcDelegate={close}>
      <div className="filter-chip">
        <Chip
          data-testid={`filterChip${placeHolder}`}
          label={chipLabel}
          variant="outlined"
          clickable
          deleteIcon={<ArrowDropDownIcon />}
          onDelete={toggleIsOpen}
          onClick={toggleIsOpen}
          className={chipActive ? 'active' : ''}
          disabled={disabled}
        />
        {isOpen && (
          <Paper elevation={1} className="options">
            {options.length === 0 ? (
              <Typography>{t('noFilterOptions')}</Typography>
            ) : (
              options.map((option) => (
                <MenuItem
                  data-testid={`filterOption${option.key.replace(' ', '_')}`}
                  key={option.key}
                  value={option.key}
                  onClick={() => handleOnMenuItemClicked(option.key, option.value)}
                  selected={initialSelectedOption?.key === option.key}
                >
                  {option.value}
                </MenuItem>
              ))
            )}
          </Paper>
        )}
      </div>
    </OutsideAlerter>
  );
};

export default FilterChip;
